import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Public eDoc session (customer flow)
 * Stores access/refresh tokens from verify-customer and the /public/me payload.
 */
export const useEdocSessionStore = create(
    persist(
        (set) => ({
            accessToken: null,
            refreshToken: null,
            accessExpiresAt: null,
            refreshExpiresAt: null,
            edocNumber: null,
            signedEdocUrl: null,
            me: null,

            setSession: (tokens = {}, edocNumber) => {
                set({
                    accessToken: tokens.accessToken || null,
                    refreshToken: tokens.refreshToken || null,
                    accessExpiresAt: tokens.accessExpiresAt ?? null,
                    refreshExpiresAt: tokens.refreshExpiresAt ?? null,
                    edocNumber: String(edocNumber || tokens.edocNumber || '').trim() || null
                });
            },

            setMe: (me) => set({ me: me || null }),

            setSignedEdocUrl: (url) => set({ signedEdocUrl: String(url || '').trim() || null }),

            /**
             * Clears auth/session but keeps signedEdocUrl and edocNumber
             * (so we can show signed URL + keep route context after submit).
             */
            clear: () =>
                set({
                    accessToken: null,
                    refreshToken: null,
                    accessExpiresAt: null,
                    refreshExpiresAt: null,
                    me: null
                }),

            clearAll: () =>
                set({
                    accessToken: null,
                    refreshToken: null,
                    accessExpiresAt: null,
                    refreshExpiresAt: null,
                    edocNumber: null,
                    signedEdocUrl: null,
                    me: null
                })
        }),
        {
            name: 'edoc-public-session',
            getStorage: () => localStorage,
            partialize: (state) => ({
                accessToken: state.accessToken,
                refreshToken: state.refreshToken,
                accessExpiresAt: state.accessExpiresAt,
                refreshExpiresAt: state.refreshExpiresAt,
                edocNumber: state.edocNumber,
                signedEdocUrl: state.signedEdocUrl
            })
        }
    )
);

